import React from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";
// import './AccessForm.scss';

const GenericBreadCrums = ({ breadcrumbs }: any) => {
  const location = useLocation();
  const { profile, loading, error } = useSelector(
    (state: RootState) => state.profile,
  );
  const isDashboard = location.pathname === "/application-dashboard";

  return (
    <div className="breadcrum-container">
      <Breadcrumbs
        separator={
          isDashboard ? "" : <span className="breadcrum-seperator"> ›</span>
        }
      >
        <Link
          to={
            profile?.user_category ? `/application-dashboard` : "/view-profile"
          }
          className="flex items-center"
        >
          <HomeIcon
            className="breadcrum-homeicon"
            sx={{ color: "#3A1C7366" }}
          />
        </Link>
        {breadcrumbs &&
          breadcrumbs.map((breadcrumb: any, index: any) =>
            index == breadcrumbs.length - 1 ? (
              <p className="body-s font-medium" key={index}>
                {breadcrumb.label}
              </p>
            ) : (
              <Link
                key={index}
                style={{ color: "#406B9D" }}
                to={breadcrumb.link}
                className="body-s font-medium"
              >
                {breadcrumb.label}
              </Link>
            ),
          )}
      </Breadcrumbs>
    </div>
  );
};

export default GenericBreadCrums;
